import { Box, Typography } from '@mui/material';
import React from 'react';
import { useAuthStore } from '../../../store/storeAuth';
import Label from '../../UI/Label/Label';
import TagInput from '../../Test/TagInput';

export interface BlobInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  parseError?: string | null;
  nodeId?: string;
  handleId?: string;
  dataConnected?: { id: string; text?: string; label?: string }[];
  isActive?: boolean;
  findColor?: { color: string };
}

const BlobInput: React.FC<BlobInputProps> = ({
  value,
  onChange,
  disabled,
  parseError = null,
  nodeId,
  handleId = 'blobConfig',
  dataConnected = [],
  isActive = false,
  findColor,
}) => {
  const { user } = useAuthStore(state => state);

  return (
    <Box sx={{ position: 'relative', width: '100%', maxWidth: '360px' }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Label
            labelName="Node config (JSON)"
            isAdvanced
            labelStyle={{
              fontSize: '12px',
              color: user?.theme === 'dark' ? '#98A2B3' : '#667085',
            }}
          />
          <Box>
            <TagInput
              name="blobConfig"
              value={value}
              onChange={(e: { target: { name: string; value: unknown } }) =>
                onChange(String(e.target.value))
              }
              handleId={handleId}
              nodeId={nodeId}
              dataConnected={dataConnected}
              isActive={isActive}
              findColor={findColor}
              labelName=""
              placeholder='{"provider":"wordpress","mode":"pull","integrationId":"...","pullObjectType":"posts"}'
              disabled={disabled}
              removeIcons
              isCollapsed={true}
              advancedCollapsed={true}
            />
          </Box>
          {parseError && (
            <Typography
              sx={{
                fontSize: '12px',
                color: user?.theme === 'dark' ? '#F59E0B' : '#EAB308',
                mt: 0.5,
                display: 'block',
              }}
            >
              {parseError}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default BlobInput;
